export const DropDownData = () => {

}

export const filterSuffixData = (val, DropDownValues) => {
  return DropDownValues.filter(el => {
    return el.value == val;
  });
};

export const filterSuffixDesc = (val, DropDownValues) => {
  return DropDownValues.filter(el => {
    return el.desc == val;
  });
};

export const filterTitleData = (val, DropDownValues) => {
  return DropDownValues.filter(el => {
    return el.value == val;
  });
};
export const filterTitleDesc = (val, DropDownValues) => {
  return DropDownValues.filter(el => {
    return el.desc == val;
  });
};

export const filterRelationDesc = (val, DropDownValues) => {
  return DropDownValues.filter(el => {
    return el.desc == val;
  });
};

export const filterRelationData = (val, DropDownValues) => {
  return DropDownValues.filter(el => {
    return el.value == val;
  });
};

export const filterGenderData = (val, DropDownValues) => {
  return DropDownValues.filter(el => {
    return el.value == val;
  });
};

export const filterGenderDesc = (val, DropDownValues) => {
  return DropDownValues.filter(el => {
    return el.desc == val;
  });
};

export const filterStateData = (val, DropDownValues) => {
  return DropDownValues.filter(el => {
    return el.value == val;
  });
};

export const filterStateDesc = (val, DropDownValues) => {
  return DropDownValues.filter(el => {
    return el.desc == val;
  });
};

export const filterCountryData = (val, DropDownValues) => {
  return DropDownValues.filter(el => {
    return el.value == val;
  });
};

export const filterCountryDesc = (val, DropDownValues) => {
  return DropDownValues.filter(el => {
    return el.desc == val;
  });
};
